import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLabelsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_6287_236)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.7812 1.22185C10.4906 0.928102 10.0156 0.924978 9.72188 1.2156C9.42813 1.50623 9.425 1.98123 9.71562 2.27498L13.7063 6.3156C14.7656 7.38748 14.7656 9.10935 13.7063 10.1812L10.2094 13.7219C9.91875 14.0156 9.92188 14.4906 10.2156 14.7812C10.5094 15.0719 10.9844 15.0687 11.275 14.775L14.775 11.2375C16.4125 9.58123 16.4125 6.91873 14.775 5.26248L10.7812 1.22185ZM7.58437 1.58435C7.20937 1.20935 6.7 0.999977 6.16875 0.999977H1.5C0.671875 0.999977 0 1.67185 0 2.49998V7.17185C0 7.7031 0.209375 8.21248 0.584375 8.58748L5.83437 13.8375C6.61562 14.6187 7.88125 14.6187 8.6625 13.8375L12.8344 9.6656C13.6156 8.88435 13.6156 7.61873 12.8344 6.83748L7.58437 1.58748V1.58435ZM1.5 2.49998H6.17188C6.30312 2.49998 6.43125 2.5531 6.525 2.64685L11.775 7.89685C11.9688 8.0906 11.9688 8.40935 11.775 8.6031L7.60313 12.775C7.40938 12.9687 7.09062 12.9687 6.89687 12.775L1.64688 7.52498C1.55313 7.43123 1.5 7.3031 1.5 7.17185V2.49998ZM4.5 4.49998C4.5 4.23476 4.39464 3.98041 4.20711 3.79287C4.01957 3.60533 3.76522 3.49998 3.5 3.49998C3.23478 3.49998 2.98043 3.60533 2.79289 3.79287C2.60536 3.98041 2.5 4.23476 2.5 4.49998C2.5 4.76519 2.60536 5.01955 2.79289 5.20708C2.98043 5.39462 3.23478 5.49998 3.5 5.49998C3.76522 5.49998 4.01957 5.39462 4.20711 5.20708C4.39464 5.01955 4.5 4.76519 4.5 4.49998Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6287_236",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "transparent"
		})
	}) })]
});
export default SvgLabelsIcon;
